import { classNames } from './classNames';
import { guid } from './guid';
import { Keys } from './keys';
import { noop } from './noop';
import { FormComponent } from './FormComponent';
import FloatingLabel from './FloatingLabel';
import dispatchEvent from './events/dispatchEvent';
import { isServerRendering } from './serverRendering';
import { Draggable } from './Draggable';
import { focusFirstFocusableChild } from './focus';
import { useRtl } from './hooks';
import { getter } from './getter';
import { setter } from './setter';
import { clone, cloneArray, cloneValue, cloneObject, cloneDate } from './clone';
export { classNames, guid, Keys, noop, FloatingLabel, FormComponent, dispatchEvent, isServerRendering, Draggable, focusFirstFocusableChild, useRtl, getter, setter, clone, cloneArray, cloneValue, cloneObject, cloneDate };
//# sourceMappingURL=main.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-react-animation/node_modules/@progress/kendo-react-common/dist/es/main.js
// module id = 59
// module chunks = 0